import React, { useMemo } from 'react'
import './Challenges.css'
import RichTextContent, { CmsText } from '../../../RichTextContent/RichTextContent'
import { useIndustriesSection } from '../../../../context/IndustryPageContext'
import { getCardsFromSection } from '../../../../services/contentApi'
import { resolveMediaUrl } from '../../../../utils/resolveMediaUrl'

import icon1 from '../../../../assets/icons/industry/icon1.png'
import icon2 from '../../../../assets/icons/industry/icon2.png'
import icon3 from '../../../../assets/icons/industry/icon3.png'
import icon4 from '../../../../assets/icons/industry/icon4.png'

const icons = [icon1, icon2, icon3, icon4]

const Challenges = () => {
  const { section, loading } = useIndustriesSection('challenges')

  const bgSrc = useMemo(() => {
    const url = section?.media?.primary?.url
    return url ? resolveMediaUrl(url) : ''
  }, [section])

  if (loading || !section?.fields) return null

  const fields = section.fields
  const cards = getCardsFromSection(section, 4)

  return (
    <section className="challenges">
      <div className="ch-header">
        {fields.subtitle ? (
          <CmsText
            content={fields.subtitle}
            as="p"
            className="ch-subtitle"
          />
        ) : null}

        {fields.title ? (
          <CmsText content={fields.title} as="h2" className="ch-title" />
        ) : null}

        {fields.description ? (
          <RichTextContent
            content={fields.description}
            className="ch-description"
          />
        ) : null}
      </div>

      <div className="ch-visual">
        <div className="ch-bg">
          {bgSrc ? <img src={bgSrc} alt="" /> : null}
        </div>

        <div className="ch-cards">
          {cards.map((card, index) => (
            <div className="ch-card" key={index}>
              <div>
                <img src={icons[index]} alt="" className="ch-icon" />
              </div>
              <div>
                <CmsText content={card.title} as="h3" />
                <RichTextContent content={card.description} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Challenges
